import React from 'react';
import {loadLanguage} from 'Utils/jwtUtil';
// Components
import Anchor from 'Components/common/Anchor';

// Actions
import {T} from 'Actions/translate';

class F1PackageOnTheGoItem extends React.Component {
    render() {
        const {item, chooseItem} = this.props;

        return (
            <Anchor onClickOfSingleTap={chooseItem}>
                <div className="header-title row">
                    <h6 className="order-num dn-number text-ellipsis">
                        <label>{T('fone_order_dn_number')}</label>
                        {item.shipmentNumber}
                    </h6>
                    {item.eta ? (
                        <div className="second-column">
                            <label>
                                {T('fone_order_estimated_delivery_time')}
                            </label>
                            <div>{item.eta}</div>
                        </div>
                    ) : null}
                </div>
                <p className="F1-num text-ellipsis row">
                    <label>{T('host_fone_order_number')}</label>
                    {item.orderNumber}
                </p>
                <p className="row clearfix">
                    <span className="f1-number text-ellipsis pull-left">
                        <label>{T('host_fone_e1_order_number')}</label>
                        {item.f1Number}
                    </span>
                    <span className="branch-name text-ellipsis pull-right">
                        <label>{T('fone_order_branch_name')}</label>
                        {item.branchName}
                    </span>
                </p>
                <p className="carrier-name text-ellipsis row">
                    <label>{T('host_logistics_company')}</label>
                    {item.carrierName}
                </p>
                <p className="replenishment-time text-ellipsis row">
                    <label>{T('fone_order_replenishment_time')}</label>
                    {item.createTime}
                </p>
                <p className="delivery-time text-ellipsis row">
                    <label>{T('fone_order_delivery_time')}</label>
                    {item.shipDate}
                </p>
            </Anchor>
        );
    }
}

export default F1PackageOnTheGoItem;
